export default __webpack_public_path__ + "static/media/powerSupply3.317769b8.svg";